export default "__VITE_ASSET__DJtR_$L0__"